import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ErrorMessage from "../common/ErrorMessage";
import { GET } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import * as _ from "lodash";
import { Button, DatePicker, Form, Row, Space } from "antd";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR } from "../../constance/color";
import { CheckOutlined } from "@ant-design/icons";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";


export default function SearchWasteWood(props) {
  const {
    onSelect,
    onBack,
  } = props;

  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const groupDate = Form.useWatch('post_baking_group_date', form);
  const inputDate = Form.useWatch('input_date', form);

  const handleSubmit = async ({ post_baking_group_date, input_date }) => {
    setLoading(true);

    try {
      const group_date = dayjs(post_baking_group_date).format(DATE_FORMAT);
      const inputDate = dayjs(input_date).format(DATE_FORMAT);
      const checkWoodResponse = await GET(URL_POST_BAKING.CHECK_POST_BAKING_GROUP, { date: group_date })
      const checkInputResponse = await GET(URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_DONE_CHECK, { date: group_date })
      const woodExists = _.get(checkWoodResponse, 'data.exists', false)
      const doneCheckExists = _.get(checkInputResponse, 'data.exists', false)
      if (!woodExists) {
        setErrorMessages(t('post_baking_waste_wood_count.errors.no_wood'))
      } else if (doneCheckExists) {
        setErrorMessages(t('post_baking_waste_wood_input.errors.done_check'))
      } else {
        onSelect(group_date, inputDate)
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ marginTop: '3rem' }}>
      <ErrorMessage message={errorMessages} />
      <Form form={form} initialValues={{ post_baking_group_date: null, type_select: null, ovens: [] }} onFinish={handleSubmit}>
        <Row justify={'center'}>
          <Form.Item
            label={t('post_baking_waste_wood_count.group_date')}
            name={'post_baking_group_date'}
            rules={[{ required: true, message: t('error_messages.validation.required') }]}>
            <DatePicker format={HUMAN_DATE_FORMAT} placeholder={t('searchs.fields.date')} style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item
            label={t('post_baking_waste_wood_input.input_date')}
            name={'input_date'}
            rules={[{ required: true, message: t('error_messages.validation.required') }]}>
            <DatePicker format={HUMAN_DATE_FORMAT} placeholder={t('searchs.fields.date')} style={{ width: '100%' }} />
          </Form.Item>
        </Row>

        <Space>
          <ColorButton
            type='primary' override={BLUE_COLOR}
            loading={loading} icon={<CheckOutlined />}
            htmlType="submit"
          >{t('confirm')}</ColorButton>
          <Button variant="filled" color="default" onClick={onBack}>{t('back')}</Button>
        </Space>

      </Form>
    </div>
  )
}



SearchWasteWood.propTypes = {
  onSelect: PropTypes.func,
  onBack: PropTypes.func,
}

SearchWasteWood.defaultProps = {
  onSelect: () => null,
  onBack: () => null,
}